// Thin wrapper around sonner. Centralises error-shape unwrapping so
// `useNotify().error(err)` works whether the caller passes an Error, an
// ApiError (with structured body), or a free-form string.

import { toast } from "sonner";
import { ApiError } from "./api-client";

function messageOf(input: unknown): string {
  if (input instanceof ApiError) {
    return input.message || `HTTP ${input.status}`;
  }
  if (input instanceof Error) {
    return input.message;
  }
  if (typeof input === "string") return input;
  return "Something went wrong";
}

export const notify = {
  success(message: string): void {
    toast.success(message);
  },
  error(input: unknown, fallback?: string): void {
    const msg = input == null && fallback ? fallback : messageOf(input);
    toast.error(msg);
  },
  info(message: string): void {
    toast(message);
  },
};

// Hook form — matches the doc's spec. Today this is a pass-through; the
// hook signature gives us a seam to add user/workspace context later
// (e.g. dedupe-by-key, persist-across-route on retry, etc.).
export function useNotify() {
  return notify;
}
